import { IJsonSerializable } from '../util/interfaces'

import { Enums } from '../common/enums'
import { SESSION_ERROR } from './session-error'
import { DBCOLLECTOR_SESSION_ERROR } from './dbcollector-session-error'

export class SESSION implements IJsonSerializable {
    public guid: string
    public time: string
    public imrWcfAddress: string
    public status: Enums.SESSION_STATUS
    public error: SESSION_ERROR

    constructor(opObject: any = null) {
        this.fromJSON(opObject)
    }

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.guid = opObj.Guid
            this.time = opObj.Time
            this.imrWcfAddress = opObj.ImrWcfAddress
            this.status = opObj.Status

            if (opObj.Error != null && opObj.Error.ErrorCode != null) {
                this.error = new DBCOLLECTOR_SESSION_ERROR(opObj.Error)
            } else {
                this.error = new SESSION_ERROR(opObj.Error)
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            Guid: this.guid,
            Time: this.time,
            ImrWcfAddressv: this.imrWcfAddress == undefined ? null : this.imrWcfAddress,
            Status: this.status,
            Error: this.error == undefined ? null : this.error ? this.error.toJSON() : null,
        }
    }

    public toString(): string {
        if (this.error && this.error.msg)
            return this.error.msg
        if (this.status == Enums.SESSION_STATUS.OK)
            return this.time + ', ' + Enums.SESSION_STATUS[this.status]
        return Enums.SESSION_STATUS[this.status]
    }

    public static isType(obj: any): boolean {
        return obj && (<SESSION>obj).guid != undefined
    }
}